import { ACTION_TYPES } from 'app/redux/features/pad-initialization/actions/padInitialization.types';

const { SCHEDULE_PRESCRIPTION_INFO_MODAL } = ACTION_TYPES;

const initialState = () => ({
  isOpened: false,
  payload: {
    data: {},
    onSuccessCallback: null
  }
});

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${SCHEDULE_PRESCRIPTION_INFO_MODAL}_OPEN`: {
      const { data, onSuccessCallback } = reduxAction.payload;
      return {
        ...state,
        isOpened: true,
        payload: {
          ...data,
          onSuccessCallback
        }
      };
    }
    case `${SCHEDULE_PRESCRIPTION_INFO_MODAL}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
